import {
  validateLength,
  validatePassword,
  validateRequired,
  validateEgyptianPhoneNumber,
  validateEgyptianPhoneNumberWithPhoneInput,
  validateMinLength,
} from "../helpers/Validation";

const ValidateLogin = (setError, user, loginMethod) => {
  let valid = true;

  if (loginMethod !== "mobile") {
    if (!validateRequired(user.name)) {
      valid = false;
      setError("name", "يجب ادخال الرقم القومي أو رقم جواز السفر");
    } else if (validateMinLength(user.name, 6)) {
      valid = false;
      setError("name", "أقل عدد حروف 6 و أقصى عدد 24");
    } else {
      setError("name");
    }
  }

  //validate password
  if (!validateRequired(user.password)) {
    valid = false;
    setError("password", "يجب إدخال كلمة المرور");
  } else {
    setError("password");
  }
  return valid;
};

const validateLoginFields = (setError, fieldName, value, loginMethod) => {
  let valid = true;
  switch (fieldName) {
    case "name":
      if (!validateRequired(value)) {
        valid = false;
        setError("name", "يجب ادخال الرقم القومي أو رقم جواز السفر”");
      } else if (validateMinLength(value, 6)) {
        valid = false;
        setError("name", "أقل عدد حروف 6 و أقصى عدد 24");
      } else {
        setError("name");
      }
      break;
    case "mobile":
      if (!validateRequired(value)) {
        valid = false;
        setError("mobile", "يجب ادخال رقم الهاتف المحمول");
      } else if (!validateEgyptianPhoneNumber(value)) {
        valid = false;
        setError(
          "umobile",
          "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول المصري",
        );
      } else if (!validateLength(value, 11)) {
        valid = false;
        setError("mobile", "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول");
      } else {
        setError("mobile");
      }
      break;
    case "password":
      if (!validateRequired(value)) {
        valid = false;
        setError("password", "يجب إدخال كلمة المرور");
      } else {
        setError("password");
      }
      break;
    default:
      break;
  }
  return valid;
};
export { validateLoginFields, ValidateLogin };
